import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-mt-10 -mb-4" }
const _hoisted_2 = { key: 1 }

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		computed
	} from 'vue'

	
	const __default__ = { name: 'JobParticipants' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()

	const {t} = useI18n()

	const groupedData = computed(() => {
		let headings = []

		if(props?.job?.portalData?.portal_witness_particpants?.length) {
			headings.push(
				{subheading: store.getLabel('148')},
				...props.job.portalData.portal_witness_particpants
			)
		}

		if(props?.job?.portalData?.portal_bearer_participants?.length) {
			headings.push(
				{subheading: store.getLabel('151')},
				...props.job.portalData.portal_bearer_participants
			)
		}

		if(props?.job?.portalData?.portal_participant_participants?.length) {
			headings.push(
				{subheading: store.getLabel('156')},
				...props.job.portalData.portal_participant_participants
			)
		}

		if(props?.job?.portalData?.portal_observer_participants?.length) {
			headings.push(
				{subheading: store.getLabel('391')},
				...props.job.portalData.portal_observer_participants
			)
		}

		return headings
	})

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noParticipants'),
      data: groupedData.value,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('149')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['job__PARTICIPANTS__witnessID::name_display'] || 
						row['job__PARTICIPANTS__bearerID::name_display'] || 
						row['job__PARTICIPANTS__participantID::name_display'] ||
						row['job__participant__CONTACTS__contactID::name_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('386')
        }, {
          default: _withCtx(({row}) => [
            (row['job__PARTICIPANTS__witnessID::unknown_checkbox'] ||
							row['job__PARTICIPANTS__bearerID::unknown_checkbox'] ||
							row['job__PARTICIPANTS__participantID::unknown_checkbox'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (row['job__participant__ROLES__roleID::name_display'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(row['job__participant__ROLES__roleID::name_display']), 1))
                : (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 2,
                    class: "h-5 w-5 text-gray-300"
                  }))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('150')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['job__PARTICIPANTS__witnessID::side_display'] ||
						row['job__PARTICIPANTS__bearerID::side_display'] ||
						row['job__PARTICIPANTS__participantID::side_display'] ||
						row['job__PARTICIPANTS__observerID::side_display'] || "—"), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('387')
        }, {
          default: _withCtx(({row}) => [
            (row['job__PARTICIPANTS__witnessID::rehearsal_checkbox'] ||
							row['job__PARTICIPANTS__bearerID::rehearsal_checkbox'] ||
							row['job__PARTICIPANTS__participantID::rehearsal_checkbox'] ||
							row['job__PARTICIPANTS__observerID::rehearsal_checkbox'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5 text-gray-300"
                }))
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ]))
}
}

})